export enum DateChangeEvent {
    BackOneDay = 'BackOneDay',
    ForwardOneDay = 'ForwardOneDay'
}
